import { render, staticRenderFns } from "./BatcDialog.vue?vue&type=template&id=70515559&scoped=true"
import script from "./BatcDialog.vue?vue&type=script&lang=js"
export * from "./BatcDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70515559",
  null
  
)

export default component.exports